// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IActivityClaimStatusDto
 */
export interface IActivityClaimStatusDto {
    /**
     * 
     * @type {string}
     * @memberof IActivityClaimStatusDto
     */
    claim_status_type?: IActivityClaimStatusDtoClaimStatusTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IActivityClaimStatusDto
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof IActivityClaimStatusDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IActivityClaimStatusDto
     */
    valid_to?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IActivityClaimStatusDtoClaimStatusTypeEnum {
    PROCESSING = 'PROCESSING',
    NEEDS_HELP = 'NEEDS_HELP',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PENDING = 'PENDING',
    REPAID = 'REPAID',
    DENIED = 'DENIED',
    DECLINED = 'DECLINED',
    REPROCESSING = 'REPROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    CANCELLED = 'CANCELLED',
    APPLIED_TO_DEDUCTIBLE = 'APPLIED_TO_DEDUCTIBLE',
    OUT_OF_POCKET = 'OUT_OF_POCKET',
    COMPLETE = 'COMPLETE',
    VOIDED = 'VOIDED',
    PAID_INELIGIBLE_EXPENSE = 'PAID_INELIGIBLE_EXPENSE',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}


/**
 * Check if a given object implements the IActivityClaimStatusDto interface.
 */
export function instanceOfIActivityClaimStatusDto(value: object): value is IActivityClaimStatusDto {
    return true;
}

export function IActivityClaimStatusDtoFromJSON(json: any): IActivityClaimStatusDto {
    return IActivityClaimStatusDtoFromJSONTyped(json, false);
}

export function IActivityClaimStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IActivityClaimStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'claim_status_type': json['claim_status_type'] == null ? undefined : json['claim_status_type'],
        'status': json['status'] == null ? undefined : json['status'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
    };
}

export function IActivityClaimStatusDtoToJSON(json: any): IActivityClaimStatusDto {
    return IActivityClaimStatusDtoToJSONTyped(json, false);
}

export function IActivityClaimStatusDtoToJSONTyped(value?: IActivityClaimStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claim_status_type': value['claim_status_type'],
        'status': value['status'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString()),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString()),
    };
}

